import { render, staticRenderFns } from "./SpWideCol.vue?vue&type=template&id=3b7de638&scoped=true&"
import script from "./SpWideCol.vue?vue&type=script&lang=js&"
export * from "./SpWideCol.vue?vue&type=script&lang=js&"
import style0 from "./SpWideCol.vue?vue&type=style&index=0&id=3b7de638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7de638",
  null
  
)

export default component.exports